export default {
  path: '/package',
  component: () => import('@/views/package/package-router.vue'),
  children: [
    {
      path: '',
      name: 'Package',
      component: () => import('@/views/package/pages/Package.vue'),
      meta: {
        name: 'แพ็กเกจ',
        icon: '/icons/package.svg',
        auth: true
      }
    },
    {
      path: 'package-create',
      name: 'PackageCreate',
      component: () => import('@/views/package/pages/PackageCreate.vue'),
      meta: {
        name: 'แพ็กเกจ',
        icon: '/icons/package.svg',
        auth: true
      }
    },
    {
      path: 'package-edit/:id',
      name: 'PackageEdit',
      component: () => import('@/views/package/pages/PackageEdit.vue'),
      meta: {
        name: 'แพ็กเกจ',
        icon: '/icons/package.svg',
        auth: true
      }
    },
    {
      path: 'package-detail/:id',
      name: 'PackageDetail',
      component: () => import('@/views/package/pages/PackageDetail.vue'),
      meta: {
        name: 'แพ็คเกจ',
        icon: '/icons/package.svg',
        auth: true
      }
    }
  ]
}
